import { useCallback, useEffect, useRef, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormValue } from '../type';
import { useValidate } from '../hooks/useValidate';
import { formatAmountDisplay } from './utils';

export function Amount() {
    const { control, setValue } = useFormContext<FormValue>();
    const { errorOnchange } = useValidate();
    const [amount] = useWatch({ control, name: ['amount'] });
    const { t } = useTranslation();

    const [displayValue, setDisplayValue] = useState(() =>
        formatAmountDisplay(amount || '')
    );
    const isInternalChange = useRef(false);

    useEffect(() => {
        if (!isInternalChange.current) {
            setDisplayValue(formatAmountDisplay(amount || ''));
        }
        isInternalChange.current = false;
    }, [amount]);

    const handleChange = useCallback(
        (value: string) => {
            const raw = value.replace(/,/g, '');
            if (raw === '' || /^\d*\.?\d*$/.test(raw)) {
                isInternalChange.current = true;
                setValue('amount', raw);
                setDisplayValue(formatAmountDisplay(raw));
            }
        },
        [setValue]
    );

    return (
        <div className="space-y-2">
            <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide ml-1">
                {t('Amount')} (WLD)
            </label>
            <div className="bg-surface-light rounded-2xl p-2 flex items-center justify-center h-[60px]">
                <input
                    className="bg-transparent border-0 text-center text-2xl font-bold text-slate-900 w-full focus:ring-0 p-0 tabular-nums"
                    placeholder="0.0"
                    type="text"
                    inputMode="decimal"
                    value={displayValue}
                    onChange={(e) => handleChange(e.target.value)}
                />
            </div>
            {errorOnchange ? (
                <p className="text-sm font-medium text-red-500 text-left px-1 pt-0.5 col-span-3">
                    {errorOnchange}
                </p>
            ) : null}
        </div>
    );
}
